import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { NAV_LINKS } from '../mock';
import Logo from './Logo';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? 'py-3' : 'py-5'}`}>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className={`flex items-center justify-between rounded-full border transition-all duration-500 ${scrolled ? 'bg-[#ede2c4]/85 backdrop-blur-md border-[#162028]/10 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] px-4 py-2.5' : 'bg-[#ede2c4]/60 backdrop-blur-sm border-[#162028]/10 px-5 py-3'}`}>
          <a href="#top" className="flex items-center -my-1">
            <Logo variant="mark" className="h-12 w-12 object-contain scale-[2.2] origin-center shrink-0" />
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="px-3.5 py-1.5 text-[13.5px] font-medium text-[#162028]/80 hover:text-[#162028] rounded-full hover:bg-[#162028]/5 transition-colors">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a href="#contact" className="hidden md:inline-flex items-center gap-1.5 rounded-full bg-[#162028] px-4 py-2 text-[13px] font-semibold text-[#ede2c4] hover:bg-[#49001B] transition-colors group">
              Connect
              <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <button onClick={() => setOpen(!open)} className="md:hidden inline-flex items-center justify-center h-9 w-9 rounded-full border border-[#162028]/15 text-[#162028]">
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-2 rounded-2xl border border-[#162028]/10 bg-[#ede2c4]/95 backdrop-blur-md p-3 shadow-lg">
            <div className="flex flex-col">
              {NAV_LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="px-3 py-2.5 text-sm font-medium text-[#162028]/80 rounded-lg hover:bg-[#162028]/5">{l.label}</a>
              ))}
              <a href="#contact" onClick={() => setOpen(false)} className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-[#162028] px-4 py-2.5 text-sm font-semibold text-[#ede2c4]">Connect <ArrowUpRight size={15} /></a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
